import { useRouter } from "next/router";

const useURLQueryParams = () => {
  const router = useRouter();

  const {
    query: { vdr, tab, source, searchVersion },
  } = router;

  return {
    vdr,
    tab,
    source,
    searchVersion,
  };
};

export default useURLQueryParams;
